import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["mainImage", "modalImage", "thumbnail"]

  currentIndex = 0

  selectThumbnail(event) {
    const thumb = event.currentTarget
    this.currentIndex = parseInt(thumb.dataset.index) || 0
    if (this.hasMainImageTarget) this.mainImageTarget.src = thumb.dataset.largeUrl
    this._highlightThumbnail()
  }

  syncModal() {
    if (this.hasModalImageTarget && this.hasMainImageTarget) {
      this.modalImageTarget.src = this.mainImageTarget.src
    }
  }

  prev() {
    const total = this.thumbnailTargets.length
    if (total === 0) return
    this.currentIndex = (this.currentIndex - 1 + total) % total
    this._showImage()
  }

  next() {
    const total = this.thumbnailTargets.length
    if (total === 0) return
    this.currentIndex = (this.currentIndex + 1) % total
    this._showImage()
  }

  // Private

  _showImage() {
    const thumb = this.thumbnailTargets[this.currentIndex]
    if (!thumb) return
    const url = thumb.dataset.largeUrl
    if (this.hasModalImageTarget) this.modalImageTarget.src = url
    if (this.hasMainImageTarget) this.mainImageTarget.src = url
    this._highlightThumbnail()
  }

  _highlightThumbnail() {
    this.thumbnailTargets.forEach((t, i) => {
      t.classList.toggle('!border-blue-500', i === this.currentIndex)
      t.classList.toggle('border-transparent', i !== this.currentIndex)
    })
  }
}
